import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Header } from './Header';

export function Layout() {
  const location = useLocation();

  // Determine page title based on route
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'Inicio';
      case '/captura':
        return 'Nueva Captura';
      case '/dashboard':
        return 'Dashboard';
      case '/historial':
        return 'Historial';
      default:
        return 'DR Referidos';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <Header title={getPageTitle()} />

      {/* Main content */}
      <main className="flex-1 pb-20">
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <Navigation />
    </div>
  );
}
